// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"945":"dashboard","9884":"admin"}[chunkId] || chunkId) + "." + {"945":"191779ea","1592":"cfcd15f0","2903":"20ad8fab","7116":"8fa9d0c3","7628":"434c7e6c","8276":"6faf635d","9884":"6e00f011"}[chunkId] + ".chunk.css";
};